/**
 * `/borne`: the visitor self-registration tablet (spec 2026-09-27 §2, §4).
 * A kiosk tree outside `_dashboard`, like `/poste`, with the station's dark
 * surface. There is no human session here: the device token is the only
 * credential, and it lives under its own storage key.
 */
import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";

import { getBorneDeviceToken } from "~/lib/borne/device-token";
import { borneRedirect } from "~/lib/borne/route";

export const Route = createFileRoute("/borne")({
  beforeLoad: ({ location }) => {
    const target = borneRedirect(
      getBorneDeviceToken() !== null,
      location.pathname,
    );
    if (target) {
      // eslint-disable-next-line @typescript-eslint/only-throw-error
      throw redirect({ to: target, replace: true });
    }
  },
  component: BorneLayout,
});

function BorneLayout() {
  return (
    <div className="station bg-background text-foreground min-h-dvh">
      <Outlet />
    </div>
  );
}
